import { AbstractAdExtendedBridge } from '@bedrock/ad-engine';

export class CommonBridge extends AbstractAdExtendedBridge {
  pause() {
    if (this.engine && this.engine.getCurrentAd()) {
      this.engine.pause();
    } else {
      this.contentHandlers.playerPause();
    }
  }

  buildTargeting(targeting) {
    return Object.keys(targeting)
      .map(key => `${key}=${encodeURIComponent(targeting[key])}`)
      .join(this.config.targetingKeysSeparator);
  }
}

export default CommonBridge;
